import { addAsset } from "../components/utilities";

const CartDrawer = {
  root: document.querySelector('#component-cart-drawer-root'),
  buttons: document.querySelectorAll('[data-toggle-cart]'),
  countWrapper: document.querySelector('[data-cart-count]'),
  settings: window.cartDrawerSettings || false,

  setCartDrawer: function() {
    const { settings, root } = CartDrawer;

    if (!root || !settings) return;
  
    // Define frete grátis
    const freeShipping = (settings.freeShippingValue > 1) ? settings.freeShippingValue : 0

    // Inicia o componente
    const componentCartDrawer = new Vnda.Component.CartDrawer({
      anchor: 'right',
      display: 'list',
      startOpen: false,
      titleCart: 'Carrinho de compras',
      disableShippingCalculation: true,
      freeShipping
    });

    // Renderiza o componente
    componentCartDrawer.render(root);

    // Salva instância para acesso global
    window.cartDrawerSettings.instance = componentCartDrawer
    CartDrawer.settings = window.cartDrawerSettings

    // dispara evento de carregamento, escutado por CartDrawer.show()
    root.dispatchEvent(new Event('vnda:cart-drawer-loaded'))
  },

  loadComponent: function() {
    const { settings } = CartDrawer;
    addAsset(settings.script, CartDrawer.setCartDrawer);
    addAsset(settings.styles);
  },

  handleCartButton: function(button) {
    // Evita múltiplos cliques caso o carrinho precisa ser instanciado primeiro
    if (button.classList.contains('-loading')) {
      return;
    }

    // Abre o cart drawer
    button.classList.add('-loading');
    CartDrawer.show(() => { button.classList.remove('-loading') }, { checarVazia: true })
  },

  // Painel de sacola vazia (o componente da Olist quebra quando não há itens)
  emptyPanel: document.querySelector('[data-cart-empty]'),

  openEmpty: function () {
    const panel = CartDrawer.emptyPanel;
    if (!panel) return;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('-open'));
    document.documentElement.classList.add('fx-no-scroll');
    const close = panel.querySelector('.fx-cart-empty-close');
    if (close) close.focus({ preventScroll: true });
  },

  closeEmpty: function () {
    const panel = CartDrawer.emptyPanel;
    if (!panel || panel.hidden) return;
    panel.classList.remove('-open');
    document.documentElement.classList.remove('fx-no-scroll');
    setTimeout(() => { panel.hidden = true; }, 300);
  },

  show: async function (callback, opcoes = {}) {

    const { root } = CartDrawer;

    // No mobile, fecha o menu primeiro
    if (window.mmenu) window.mmenu.close()

    // Sacola vazia: abre o painel do tema em vez do componente. Só no clique do ícone; depois de
    // adicionar um produto (store.js) a sacola da Olist abre direto, sem depender da contagem.
    const itens = opcoes.checarVazia ? Number(await CartDrawer.getCartItens()) : 1;
    if (opcoes.checarVazia && itens === 0) {
      CartDrawer.openEmpty();
      if (typeof callback === 'function') callback();
      return;
    }

    // Instancia o componente, caso ainda não exista
    if (!CartDrawer.settings.instance) CartDrawer.loadComponent();

    // Observa criação da instância inicial, caso não tenha
    if (CartDrawer.settings.instance === false) {
      root.addEventListener('vnda:cart-drawer-loaded', () => {
        CartDrawer.settings.instance.open()
        if (typeof callback === 'function') callback()
      })
    } else {
      // Já possui cart drawer instanciado, retorna abertura
      CartDrawer.settings.instance.open();
      if (typeof callback === 'function') callback()
    }
  },

  getCartItens: async function () {
    try {
      // Sem cache: a CDN chegou a guardar "/carrinho/itens" e devolver 0 com produto na sacola
      const response = await fetch(`/carrinho/itens?_=${Date.now()}`, { cache: 'no-store', credentials: 'same-origin' });
      const itens = await response.json()
      return itens;

    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
    }
  },

  updateCartCount: async function (_itemsCount = null) {
    let items = _itemsCount;
    if (_itemsCount == null) items = await CartDrawer.getCartItens();

    this.countWrapper.innerHTML = items;
  },

  init: function () {
    const _this = this;
    const { buttons } = _this;

    // Atualiza o contador de itens do carrinho
    _this.updateCartCount();

    // Fecha o painel de sacola vazia (fundo, X ou Esc)
    if (_this.emptyPanel) {
      _this.emptyPanel.querySelectorAll('[data-cart-empty-close]').forEach(el => {
        el.addEventListener('click', () => _this.closeEmpty());
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') _this.closeEmpty();
      });
    }

    if (buttons.length > 0) buttons.forEach(button => {
      button.addEventListener('click', () => {
        _this.handleCartButton(button)
      })
    })
  },
};

export default CartDrawer;
